import { validationRules } from '../../../../../../services/validation/rules/validationRules'
import { ValidationSchema } from '../../../../../../@types/validation-types'
import {
  defaultContactInfo,
  defaultDescription,
  useManualAndInternationalAddress,
} from '../../../../../../services/validation/flow/defaultSchemas'

export const webViewPropertyOwnerApartmentRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    startRentalDate: validationRules.startRentalDateRequired,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  objectDetails: {
    floor: validationRules.floor,
    totalFloorsNumber: validationRules.totalFloorsWithDependingFloorNumber,
  },
  costs: {
    price: validationRules.price,
    additionalCosts: validationRules.additionalCosts,
    heatingCosts: validationRules.heatingCosts,
    deposit: validationRules.deposit,
  },
  contactInfo: defaultContactInfo,
}
